import ApiService from '../../../common/ApiCalls';
import { chunkArray } from '../../shared/utils/chunk-array';

/**
 * Updates values by sending them to the API in chunks of 25.
 *
 * @param {Object} fullPayload - The complete payload object.
 * @param {Array} fullPayload.values - Array of values to be updated.
 * @returns {Promise<void>} - Resolves when all values are successfully updated.
 * @throws {Error} - Throws an error if the API request fails
 */
export const updateValues = async (fullPayload) => {
  const { values } = fullPayload;

  if (!Array.isArray(values) || !values.length) {
    return;
  }

  // TODO: for demo purposes. Will be removed after
  if (window._proximFailReques) {
    throw new Error('Test failure');
  }

  const chunked = chunkArray(values, 25);

  for (let i = 0; i < chunked.length; i++) {
    const partialPayload = { values: chunked[i] };
    const response = await ApiService().setValues(partialPayload);

    if (response?.error) {
      console.error(response?.error);
      throw new Error(response.error);
    }
  }
};
